module.exports = __webpack_public_path__ + "img/ust-1-1360x780-c.46f34255.jpg";